import type { AccountDto } from '@/server/application/account-service'
import { normalizePreferredLanguage } from '@/server/domain/language'
import { parseOneMinutePackOffer } from '@/server/domain/one-minute-pack'

/**
 * La cuenta tal y como la ve el cliente: exactamente el `AccountDto` del
 * servidor, así que un campo nuevo allí obliga a tratarlo aquí. Llega igual de
 * los tres endpoints que la devuelven (`/api/auth/sync` dentro de `user`,
 * `/api/account` en GET y PUT, y `/api/dashboard` en `account`), y se lee en un
 * único sitio: `parseAccountSnapshot`.
 */
export type AccountSnapshot = AccountDto

/**
 * La frontera de confianza con el servidor: recibe JSON sin tipar. Sin email o
 * sin saldo numérico no hay cuenta que mostrar, así que lanza; el resto cae a su
 * valor seguro (sin PIN, sin trial, sin oferta, sin consentimiento).
 */
export function parseAccountSnapshot(dto: unknown): AccountSnapshot {
  const fields = (typeof dto === 'object' && dto !== null ? dto : {}) as Record<string, unknown>
  if (typeof fields.email !== 'string' || typeof fields.availableMinutes !== 'number') {
    throw new Error('Invalid account response')
  }

  return {
    email: fields.email,
    availableMinutes: fields.availableMinutes,
    preferredLanguage: normalizePreferredLanguage(fields.preferredLanguage),
    hasPin: fields.hasPin === true,
    trialAvailable: fields.trialAvailable === true,
    // Sin veredicto del servidor no se ofrece el pack.
    oneMinutePackOffer: parseOneMinutePackOffer(fields.oneMinutePackOffer),
    marketingConsent: fields.marketingConsent === true
  }
}
